<template>
    <AppForm
        v-if="loaded"
        :loading="loading"
        :is-new="isNew"
        heading="Endpoint"
        @submit="submitHandler"
    >
        <template v-slot:main>
            <FormGroup
                label="Title"
                label-for="title"
            >
                <InputField
                    v-model="endpoint.title"
                    :required="true"
                    name="title"
                    type="text"
                />
            </FormGroup>
            <FormGroup label="Locale">
                <AppSelect
                    v-model="endpoint.locale"
                    :items="locales"
                />
            </FormGroup>
            <FormGroup label="Removed products">
                <Relationship
                    :active-items="endpoint.removed_products"
                    :short-article-number="true"
                    endpoint="/api/products/all"
                    @addItem="item => endpoint.removed_products.push(item.id)"
                    @removeItem="index => endpoint.removed_products.splice(index, 1)"
                />
            </FormGroup>
            <FormGroup label="Removed product categories">
                <Relationship
                    :active-items="endpoint.removed_product_categories"
                    endpoint="/api/product-categories/all"
                    @addItem="item => endpoint.removed_product_categories.push(item.id)"
                    @removeItem="index => endpoint.removed_product_categories.splice(index, 1)"
                />
            </FormGroup>
            <FormGroup label="Removed documents">
                <Relationship
                    :active-items="endpoint.removed_documents"
                    endpoint="/api/documents/all"
                    @addItem="item => endpoint.removed_documents.push(item.id)"
                    @removeItem="index => endpoint.removed_documents.splice(index, 1)"
                />
            </FormGroup>
            <FormGroup label="Removed document categories">
                <Relationship
                    :active-items="endpoint.removed_document_categories"
                    endpoint="/api/document-categories/all"
                    @addItem="item => endpoint.removed_document_categories.push(item.id)"
                    @removeItem="index => endpoint.removed_document_categories.splice(index, 1)"
                />
            </FormGroup>
        </template>
        <template
            v-slot:side
            v-if="!isNew"
        >
            <div class="timestamps mb-6">
                <p>Created: {{ endpoint.created_at }}</p>
                <p>Updated: {{ endpoint.updated_at }}</p>
            </div>
            <div class="endpoints">
                <h3>Links</h3>
                <a
                    v-for="link in endpoint.links"
                    :key="link.url"
                    :href="link.url"
                    target="_blank"
                    class="endpoint"
                >
                    {{ link.label }}
                </a>
            </div>
        </template>
    </AppForm>
</template>

<script>
import AppForm from '../../components/form/AppForm.vue';
import FormGroup from '../../components/form/FormGroup.vue';
import InputField from '../../components/form/InputField.vue';
import AppSelect from '../../components/form/AppSelect.vue';
import Relationship from '../../components/form/Relationship.vue';
import { get, store, update } from '../../utils/apiHelper';
import { locales } from '../../utils/translate';

export default {
    components: {
        AppForm,
        FormGroup,
        InputField,
        AppSelect,
        Relationship,
    },
    props: {
        isNew: {
            type: Boolean,
            default: true,
        },
    },
    data: () => ({
        loaded: false,
        loading: false,
        endpoint: {
            title: null,
            locale: null,
            removed_products: [],
            removed_product_categories: [],
            removed_documents: [],
            removed_document_categories: [],
        },
    }),
    computed: {
        locales() {
            return [{ label: 'Chose locale', value: null }, ...locales.map(locale => ({
                label: locale,
                value: locale,
            }))];
        },
    },
    async created() {
        if (!this.isNew) {
            this.endpoint = await get(`/api/endpoints/${this.$route.params.id}`);

            this.endpoint.removed_products = this.endpoint.removed_products
                ? this.endpoint.removed_products : [];

            this.endpoint.removed_product_categories = this.endpoint.removed_product_categories
                ? this.endpoint.removed_product_categories : [];

            this.endpoint.removed_documents = this.endpoint.removed_documents
                ? this.endpoint.removed_documents : [];

            this.endpoint.removed_document_categories = this.endpoint.removed_document_categories
                ? this.endpoint.removed_document_categories : [];
        }

        this.loaded = true;
    },
    methods: {
        async submitHandler() {
            this.loading = true;

            if (this.isNew) {
                await this.create();
            } else {
                await this.update();
            }

            this.loading = false;
        },
        async create() {
            const res = await store('/api/endpoints', this.endpoint);

            if (res) {
                this.$router.push('/endpoints');
            }
        },
        async update() {
            await update(`/api/endpoints/${this.$route.params.id}`, this.endpoint);
        },
    },
};
</script>

<style lang="postcss" scoped>
.endpoints h3 {
    margin-bottom: 20px;
}
.endpoint {
    display: block;
    margin-bottom: 4px;
    text-decoration: underline;
    &:hover {
        color: var(--primary);
    }
}
</style>
